import React from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'

import getFieldTypeProps from 'js/components/Form/CustomFields/helpers/getFieldTypeProps'
import { FormField } from 'js/components/Form/CustomFields/types'
import FormItem from 'js/components/Form/FormItem'
import { Col, Row } from 'js/components/Grid/Grid'

type CustomField = {
    guid: string
    field: FormField
}

type InputLanguageProps = {
    TitleFieldComponent: React.ElementType
    DescriptionFieldComponent: React.ElementType
}

const InputLanguage = ({
    TitleFieldComponent,
    DescriptionFieldComponent,
}: InputLanguageProps) => {
    const {
        control,
        formState: { errors },
    } = useFormContext()

    const { fields } = useFieldArray({
        control,
        name: 'formFields',
    }) as { fields: CustomField[] }

    const titleIndex = fields.findIndex(
        (field: CustomField) =>
            field.field.fieldType === 'titlePlaceholderField',
    )

    const renderField = ({ guid, field }: CustomField, i: number) => {
        if (field.fieldType === 'titlePlaceholderField') {
            return TitleFieldComponent
        }

        if (field.fieldType === 'richDescriptionPlaceholderField') {
            return DescriptionFieldComponent
        }

        return (
            <FormItem
                key={guid}
                control={control}
                name={`formFields.${i}.value`}
                error={errors.formFields?.[i]?.value?.message}
                {...getFieldTypeProps(field)}
            />
        )
    }

    return (
        <Row $spacing={24}>
            {fields?.map((field: CustomField, i: number) => {
                const isFullWidth = i >= titleIndex
                return (
                    <Col
                        key={field.guid}
                        mobileLandscapeUp={isFullWidth ? 1 : 1 / 2}
                    >
                        {renderField(field, i)}
                    </Col>
                )
            })}
        </Row>
    )
}

export default InputLanguage
